import { testIdAttr, testIdFor } from '@src/components/testId';
import { Typography } from '@src/components/Typography/Typography';
import './HomeTitle.css';

export interface HomeTitleProps {
  /** The wordmark — "тайный санта" / "secret santa". */
  name: string;
  /** The line under it — the free-organizer sentence. */
  title?: string;
  testId?: string;
}

/**
 * The home H1, with an optional supporting line for layouts that need it.
 */
export function HomeTitle({ name, title, testId }: HomeTitleProps) {
  const words = name.trim().split(/\s+/);
  return (
    <h1 className="home-title" {...testIdAttr(testId)}>
      <Typography
        as="span"
        role="title/landing"
        className="home-title__mark"
        {...testIdAttr(testIdFor(testId, 'mark'))}
      >
        {words.map((word, index) => (
          <span key={`${word}-${index}`} className="home-title__word">
            {index > 0 && <span className="home-title__space"> </span>}
            {word}
            {index === words.length - 1 && <span className="home-title__dot">.</span>}
          </span>
        ))}
      </Typography>
      {title && (
        <Typography as="span" role="title/section" className="home-title__line">
          {title}
        </Typography>
      )}
    </h1>
  );
}
